import PropTypes from 'prop-types'
import React, { Component } from 'react'

import { inject, observer } from 'mobx-react'
import BasePage from '../../base/components/BasePage'
import Loader from '../../shared/components/Loader'

@inject('message')
@observer
export default class UserBase extends Component {

  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]),
    message: PropTypes.object.isRequired,
  }

  componentWillMount() {
    // const { message } = this.props
    // if (!message.length && !message.collection.length) {
    //   message.load()
    // }
  }

  render() {
    const children = this.props.message.loading
      ? <Loader>Nachrichtendaten werden geladen...</Loader>
      : this.props.children

    return (
      <BasePage type="message">
        {children}
      </BasePage>
    )
  }
}



// WEBPACK FOOTER //
// ./src/message/containers/Container.js